export default __webpack_public_path__ + "static/media/7.57dc56ea.jpg";